import { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import LibraryLayout from "./LibraryLayout";
import { librariesList } from "../../api/Library";
import DuePaymentTracker from "./components/DuePaymentTracker";

export default function LibraryDues() {
  const [loading, setLoading] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [libraryId, setLibraryId] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    librariesList()
      .then((r) => {
        if (r?.data?.status) setLibraries(r.data.data ?? []);
      })
      .catch((error) => {
        SweetAlertShow(
          "error",
          "Error",
          error?.response?.data?.message ??
            error?.response?.message ??
            error?.message,
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                      <div>
                        <h3 className="mb-0 text-primary">Library Dues</h3>
                        <p className="m-0">
                          View pending and overdue library fee payments
                        </p>
                      </div>
                      <select
                        className="form-select"
                        style={{ width: "220px" }}
                        value={libraryId}
                        onChange={(e) => setLibraryId(e.target.value)}
                      >
                        <option value="">All Libraries</option>
                        {libraries.map((library) => (
                          <option key={library.id} value={library.id}>
                            {library.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <DuePaymentTracker
                      key={refreshKey}
                      libraryId={libraryId}
                      onRefresh={() => setRefreshKey((key) => key + 1)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
